/** type de données */
export enum DATA_KIND {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  INT = 'INT',
  DATE = 'DATE',
  TIME = 'TIME',
  BOOLEAN = 'BOOLEAN',
  MEASURE = 'MEASURE',
  CONSTANT = 'CONSTANT',
  WEIGHT = 'WEIGHT',
  OBJECT = 'OBJECT', // pour un FD ou un chrono
  FILE = 'FILE',
  LIST = 'LIST', // liste de clés / valeurs
  BINARY_MULTI = 'BINARY_MULTI' // multi images
}

// constantes des numériques, à chercher dans le fichier de trad
export enum WIZ_NUMERIC_CONSTANT {
  DECIMAL_SEPARATOR = 'numeric.decimal.separator',
  THOUSAND_SEPARATOR = 'numeric.thousand.separator',
  NB_DECIMAL = 'numeric.nb.decimal',
}

// type de clé
export enum KEY_KIND {
  KEY = 'KEY',
  FILTER_KEY = 'FILTER_KEY',
  MEASURE = 'MEASURE',
  SCEN = 'SCEN',
  MASTER = 'MASTER' // filtre depuis un masterWidget
}

// constantes d'actions
export enum EM_ACTION {
  CREATE = 'C',
  UPDATE = 'U',
  DELETE = 'D',
}

// modes possibles pour les Visions
export enum RUN_MODE {
  PROD = 'PROD',
  QUAL = 'QUAL',
  TEST = 'TEST'
}

/** type de champs / valeurs */
export enum FIELD_KIND {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  INT = 'INT',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  MEASURE = 'MEASURE',
  CONSTANT = 'CONSTANT',
  WEIGHT = 'WEIGHT',
  ANY = 'ANY',
  BINARY = 'BINARY', // pour les images
  OBJECT = 'OBJECT', // pour un FD ou un chrono
  TRS_LABEL = 'TRS_LABEL', // un libellé traductible
  SUB_LINES = 'SUB_LINES', // lignes filles du prochain step
  LIST = 'LIST', // série de clés-valeurs
  COMMENT = 'COMMENT', // texte long
  ACTION = 'ACTION', // code de fonction connect
  FORMULA = 'FORMULA', // une formule de calcul...
  FILE = 'FILE', // un fichier du storage
  COLOR = 'COLOR', // une couleur (un Uint #00000000)
  TIME = 'TIME', // format heure
  FILTER = 'FILTER', // liste de valeurs depuis un FD
  WORKFLOW = 'WORKFLOW', // un ou une collection de messages
  BINARY_MULTI = 'BINARY_MULTI', // pour les images, en masse
}

// Liste des entités 
export enum ENTITY_KIND {
  BASELINE = 'Baseline',
  BASELINE_DATA = 'BaselineData',
  CHRONOCODE = 'ChronoCode',
  FORMAT = 'Format',
  FREEDATA = 'FreeData',
  FREEDATA_VALUE = 'FreeDataValue',
  MEASURE = 'Measure',
  VISION = 'Vision',
  WEIGHT_GRID = 'WeightGrid',
  SCENARIO = 'Scenario'
}

// mode de chargement des données de widget
export enum COMPUTE_MODE {
  LOCAL = 'LOCAL',
  COMPUTE = 'COMPUTE'
}